import Photo from '../ui/Photo';
import { connect } from 'react-redux';
import {
  photoSubmit,
  photoFormSubmit,
  skipSubmit,
  goBack,
  invalidatePhotos,
  fetchPhotosIfNeeded
 } from '../../actions';

const mapStateToProps = (state, props) => ({
  page: state.page,
  intl: props.intl,
  user: state.user,
  content: state.content,
  photos: state.photos,
  market: state.market,
  territory: state.territory,
  uploader: state.uploader
});

const mapDispatchToProps = dispatch =>
  ({
    onPhotoSubmit(payload) {
       dispatch(
         photoSubmit(payload)
       )
    },
    onPhotoFormSubmit(payload) {
       dispatch(invalidatePhotos())
       dispatch(
         photoFormSubmit(payload)
       )
    },
    onPhotoDestroySubmit(payload) {
      dispatch(invalidatePhotos())
      dispatch(
        photoFormSubmit(payload)
      )
    },
    onSkipSubmit(payload) {
       dispatch(
         skipSubmit(payload)
       )
    },
    onGoBack(payload) {
       dispatch(
         goBack(payload)
       )
    },
    onFetchPhotosIfNeeded(payload) {
      dispatch(fetchPhotosIfNeeded())
    },
    onPhotosRefresh(payload) {
      dispatch(invalidatePhotos())
      dispatch(fetchPhotosIfNeeded())
    }
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(Photo);

export default Container;
